import { ListColumn, ListColumnAlignment } from '@/interfaces'
import { computed } from 'vue'

const draftsCols = computed<ListColumn[]>(() => {
  return [
    {
      name: 'row_selection',
      title: '',
      width: 6,
      alignment: ListColumnAlignment.Center,
      sortable: false,
      position: 0,
      priority: 0,
      minWidthInPx: '60px',
      maxWidthInPx: '60px'
    },
    {
      name: 'video_title',
      title: 'video-drafts-title',
      width: 20,
      alignment: ListColumnAlignment.Center,
      sortable: true,
      offset: 140,
      position: 1,
      priority: 1,
      expand: true
    },
    {
      name: 'duration',
      title: 'library-filters-duration',
      width: 12,
      alignment: ListColumnAlignment.Center,
      sortable: true,
      position: 2,
      priority: 2
    },
    {
      name: 'orientation',
      title: 'settings-content-content-sources-orientation',
      width: 12,
      alignment: ListColumnAlignment.Center,
      sortable: true,
      position: 3,
      priority: 3
    },
    {
      name: 'video_settings',
      title: 'status',
      width: 15,
      alignment: ListColumnAlignment.Center,
      sortable: true,
      position: 4,
      priority: 4
    },
    {
      name: 'created_at',
      title: 'content-uploaded-date',
      width: 12,
      alignment: ListColumnAlignment.Center,
      sortable: true,
      position: 5,
      priority: 5,
      minWidthInPx: '150px'
    },
    {
      name: 'actions',
      title: '',
      width: 7,
      alignment: ListColumnAlignment.Center,
      position: 6,
      priority: 0,
      minWidthInPx: '120px'
    }
  ]
})

export default draftsCols
